<template>
    <div>

      <TotalAndAssignedCards
        :dataLoaded="dataLoaded"
        :totalItems="totalItems"
        :totalSubItems="totalSubItems"
        :totalAssignedToYourTeams="totalAssignedToYourTeams"
        :totalAssignedToYou="totalAssignedToYou"
        :showOpenItemsOnly="showOpenItemsOnly"
        v-model:filterByMyTeams="filterByMyTeams"
        v-model:filterByMe="filterByMe"
        @filterChange="handleCardFilterChange"
        @update:showOpenItemsOnly="reloadWithOpenItemsOnly"
      />

      <v-row>
        <v-col cols="12" md="8">
          <StackedHorizontalBarChart
            :title="$t('drawingBreakdown')"
            :exportFilename="$t('drawingBreakdown') + '.png'"
            v-bind="drawingChart"
            :filterContext="filterContext"
            :chartFontColor="chartFontColor"
            :dataLoaded="dataLoaded"
          />
        </v-col>
        <v-col cols="12" md="4">
          <StackedHorizontalBarChart
            :title="$t('itemBreakdown')"
            :exportFilename="$t('itemBreakdown') + '.png'"
            v-bind="categoryChart"
            :filterContext="filterContext"
            :chartFontColor="chartFontColor"
            :dataLoaded="dataLoaded"
            v-model:currentLevel="categoryLevel"
          />
        </v-col>
      </v-row>

      <!-- Items Data Table -->
      <v-row>
        <v-col cols="12" md="12">
          <ItemsGrid v-bind="grid" />
        </v-col>
      </v-row>
    </div>
  </template>

<script src="./model.js"></script>
<style src="./style.css" scoped></style>
